// frontend/src/services/api/adminAPI.js
import api from "./config";

const adminAPI = {
  // System Statistics
  getSystemStatistics: () => api.get("/admin/statistics"),

  // Reseller Management
  getAllResellers: () => api.get("/admin/resellers"),
  getTopResellers: () => api.get("/admin/resellers/top"),
  getResellerDetails: (resellerId) => api.get(`/admin/resellers/${resellerId}`), // Add this method
  getUserTransactions: (userId) => api.get(`/admin/transactions/${userId}`), // Add this method

  adjustCredits: (resellerId, data) =>
    api.post(`/admin/credits/adjust/${resellerId}`, data),

  createReseller: (resellerData) => api.post("/admin/resellers", resellerData),
  getResellerOrders: (resellerId) =>
    api.get(`/admin/resellers/${resellerId}/orders`),

  getRecentOrders: () => api.get("/admin/orders/recent"),

  // ESIM Management
  getAllESIMOrders: () => api.get("/admin/esim-orders"),
  getESIMPackages: () => api.get("/admin/esim-packages"),
  createESIMPackage: (data) => api.post("/admin/esim-packages", data),
  updateESIMPackage: (id, data) => api.put(`/admin/esim-packages/${id}`, data),
  deleteESIMPackage: (id) => api.delete(`/admin/esim-packages/${id}`),

  // Email Templates
  getEmailTemplates: () => api.get("/admin/email-templates"),
  createEmailTemplate: (data) => api.post("/admin/email-templates", data),
  updateEmailTemplate: (id, data) =>
    api.put(`/admin/email-templates/${id}`, data),
  deleteEmailTemplate: (id) => api.delete(`/admin/email-templates/${id}`),

  // Transactions
  getTransactionStats: (timeRange) =>
    api.get(`/admin/transactions/stats`, { params: { timeRange } }),
  getAllTransactions: () => api.get("/admin/transactions"),

  // Settings
  updateSettings: (settings) => api.put("/admin/settings", settings),
  deleteReseller: (resellerId) => api.delete(`/admin/resellers/${resellerId}`),

  updateReseller: (resellerId, data) =>
    api.put(`/admin/resellers/${resellerId}`, {
      username: data.username,
      email: data.email,
      password: data.password,
      markupPercentage: data.markupPercentage,
      allowedPackages: data.allowedPackages,
      packagePricing: data.packagePricing || {}, // Ensure this is included
    }),
};

export default adminAPI;
